import React from 'react'
import './Home.css'
import Lottie from 'lottie-react';
import animationData from '../Home/lottie/animation_lnigcwun.json';
import Our_Service from '../Servicess/Our_Service';



export default function Home() {
  return (
    <section id='home'>
      <div className='container'>
        <div style={{paddingTop:"15%",color:"white"}}>
        <h2 className='first-text'>“Unleash the Future with”</h2>
        <h1 className='main-font' >LankaTech Innovations</h1>
        <p className='second-font' >At LankaTech Innovatons., we are dedicated to driving innovation and delivering cutting-edge technology solutions to meet your business needs. With a relentless commitment to excellence, we strive to be your trusted partner in the ever-evolving world of technology.</p>
        </div>
       <div>
     
       </div>
        {/* <div className='btn-contact' style={{marginTop:"20%",textAlign:"center"}}>
            <button style={{marginBottom:100 ,width:200,height:50,borderRadius:10,backgroundColor:"#E6E6E6",border:"none"}} ></button>
        </div> */}
        <Our_Service/>
        
        
    </div>
   
    </section>
  )
}
